import AdminDataTable from "../../core/DataTable/DataTable";

export function ZahraFootersList() {
    return <AdminDataTable collection="footers" columns={[
        {
            name: "ID",
            field: "id",
            type: "text",
            edit: false,
        },
        {
            name: "Title",
            field: "title",
            type: "text"
        },
        {
            name: "Description",
            field: "description",
            type: "text",
        },
        {
            name: "Created At",
            field: "createdAt",
            type: "datetime",
            edit: false,
        },
        {
            name: "Updated At",
            field: "updatedAt",
            type: "datetime",
            edit: false,
        },
    ]} />
}
